import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { SharedComponentsUtil } from '../utils/classes/SharedComponentsUtil';
import { MessageUtilService } from '../utils/service/message-util.service';
import { TextAreaService } from './text-area.service';

@Component({
  selector: 'text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
})
export class TextAreaComponent
  implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor
{
  @Input() format: string = 'M';
  @Input() showLabel: boolean = true;
  @Input() label: any = null;
  @Input() maxLength = null;
  @Input() readonly: boolean = false;
  @Input() next: any;
  @Input() nextIsDisable: any;
  @Input() back: any;
  @Input() backIsDisable: any;
  @Input() required: boolean = false;
  @Input() validatorMessage: boolean = false;
  @Input() validatorAlert: boolean = false;
  @Input() tooltipMessage: boolean = true;
  @Input() submitted: boolean = true;
  @Input() cols: number | any = null;
  @Input() rows: number | any = null;
  @Input() height: string = '';
  @Input() width: string = '';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() onchange: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() onfocus: EventEmitter<any> = new EventEmitter();
  @Output() onNext: EventEmitter<any> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @ViewChild('textArea') textArea: any;
  controls: any;
  value: any;
  sharedComponentsUtil = new SharedComponentsUtil();

  constructor(
    private messageUtilService: MessageUtilService,
    private textAreaService: TextAreaService
  ) {
    this.format = this.textAreaService.getFormat();
    this.showLabel = this.textAreaService.getShowLabel();
    this.validatorMessage = this.textAreaService.getValidatorMessage();
    this.tooltipMessage = this.textAreaService.getTooltipMessage();
    this.submitted = this.textAreaService.getSubmitted();
    this.validatorAlert = this.textAreaService.getValidatorAlert();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.submitted) {
      if (this.controls !== undefined && changes.submitted.currentValue) {
        this.controls.markAsDirty();
        this.controls.markAsTouched();
      }
    }
  }

  ngOnInit() {}

  ngAfterViewInit(): void {}

  onChange = (_: any) => {};
  onValidationChange = () => {};
  onTouch = () => {};
  focus = () => {
    this.textArea.nativeElement.focus();
    this.textArea.nativeElement.select();
  };

  onBlur(value: string): void {
    // this.value = this.formatInput(value);
    this.onTouch();
    // this.onValidationChange();
    // this.onChange(this.value);
    this.blur.emit(this.formatInput(value));
  }

  onFocus(evt: any) {
    this.textArea.nativeElement.select();
    this.onfocus.emit(evt);
  }

  onInput(evt: any) {
    const value = this.formatInput(evt);
    this.onTouch();
    this.onChange(value);
    this.onValidationChange();
    this.change.emit(value);
    this.onchange.emit(value);
  }

  writeValue(value: any): void {
    if (value) {
      this.value = this.formatInput(value);
      this.onChange(this.value);
    } else {
      this.value = null;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | any {
    this.controls = control;
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  formatInput(value: any) {
    if (this.format === 'M' && value != null && value != '') {
      return value.toString().toUpperCase();
    } else if (this.format === 'm' && value != null && value != '') {
      return value.toString().toLowerCase();
    } else {
      return value;
    }
  }

  ArrowRight(e: any) {
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(
        this.controls,
        this.validatorAlert,
        this.label
      );
      if (validator.error) {
        this.messageUtilService.getMessageError(
          '000046',
          'Error',
          validator.message
        );
        return;
      }
    }
    if (this.next != undefined) {
      if (this.next.disabled || this.next.readonly) {
        if (this.nextIsDisable != undefined) {
          this.nextIsDisable.focus();
        }
      } else {
        this.next.focus();
      }
    } else {
      if (this.nextIsDisable != undefined) {
        this.nextIsDisable.focus();
      } else {
        this.onNext.emit();
      }
    }
  }

  ArrowLeft(e: any) {
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(
        this.controls,
        this.validatorAlert,
        this.label
      );
      if (validator.error) {
        this.messageUtilService.getMessageError(
          '000046',
          'Error',
          validator.message
        );
        return;
      }
    }
    if (this.back != undefined) {
      if (this.back.disabled || this.back.readonly) {
        if (this.backIsDisable != undefined) {
          this.backIsDisable.focus();
        }
      } else {
        this.back.focus();
      }
    } else {
      if (this.backIsDisable != undefined) {
        this.backIsDisable.focus();
      } else {
        this.onBack.emit();
      }
    }
  }
}
